__webpack_require__.p = "https://s3cdn.wainao.me/react-static/special-reports/indiscriminate-attacks/";